import { QUERY_KEYS } from 'api/query-keys';
import { sharedWorkTemplateService } from 'api/services';
import { useQuery } from 'react-query';
import { useSiteDetection } from 'shared/hooks';
import { CACHE_TIME_LONG, STALE_TIME_LONG } from 'shared/react-query/query-defaults';

export const useGetWorkTemplateDefaults = () => {
  const { site } = useSiteDetection();
  const queryFn = async () => await sharedWorkTemplateService.getWorkTemplateDefaults(site);

  return useQuery(QUERY_KEYS.getWorkTemplateDefaults(), {
    queryFn,
    cacheTime: CACHE_TIME_LONG,
    staleTime: STALE_TIME_LONG,
  });
};
